import { render, staticRenderFns } from "./ColorPage.vue?vue&type=template&id=e036b032&scoped=true&"
import script from "./ColorPage.vue?vue&type=script&lang=js&"
export * from "./ColorPage.vue?vue&type=script&lang=js&"
import style0 from "./ColorPage.vue?vue&type=style&index=0&id=e036b032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e036b032",
  null
  
)

export default component.exports